import { SlotCardProps } from '#vessel/overview'
import { useT } from 'apprise-frontend-core/intl/language'
import { Grid } from 'apprise-ui/grid/grid'
import { NamedProperty, NamedPropertyContext } from 'apprise-ui/utils/namedproperty'
import { PriorTrxAuthPatch } from './model'

import { usePriorTrxAuthzList } from '#trxauth.prior/list'
import { DateLabel } from '#utils/datelabel'
import { Label } from 'apprise-ui/label/label'
import { Tip } from 'apprise-ui/tooltip/tip'
import './styles.scss'

import { classname } from 'apprise-ui/component/model'
import { IoShieldCheckmark } from 'react-icons/io5'

export const PriorTrxAuthzOverview = (props: SlotCardProps<PriorTrxAuthPatch>) => {

    const t = useT()

    const { showChange, age } = props

    const listfor = usePriorTrxAuthzList()


    const fulllist = listfor(age)
    const previousEntries = listfor(age + 1)


    return <NamedPropertyContext.Provider value={{ highlightMode: 'none' }}>



        <Grid rowGap={8} columnGap={10} >

            <Grid.Row>

                <Grid.Col width={20} />

                <Grid.Col width={210} >
                    <NamedProperty className='trxauthz-header'  name={t('priortrxauthz.period')} />
                </Grid.Col>

                <Grid.Col width={280}>
                    <NamedProperty className='trxauthz-header' name={t('priortrxauthz.number_col_long')} />
                </Grid.Col>


                <Grid.Col >
                    <NamedProperty className='trxauthz-header' name={t('priortrxauthz.entity_col_long')} />
                </Grid.Col>


                <Grid.Col width={130}>
                    <NamedProperty className='trxauthz-header'  name={t('priortrxauthz.reportedon_col')} />
                </Grid.Col>

            </Grid.Row>

            {

                fulllist.map((entry, i) => {

                    const previous = previousEntries.find(previous => previous.key === entry.key)

                    const status = entry.active ? `active` : entry.expired ? `expired` : `inactive`

                    return <Grid.Row key={i} className={classname(`authz-${status}`, showChange && !previous && 'authz-new')}>

                        <Grid.Col className='auth-icon' width={20}>
                            <Tip tip={t(`priortrxauthz.${status}_tip`)}>
                                <IoShieldCheckmark style={{ position: 'relative', top: 6, width: '100%' }} size={14} />
                            </Tip>
                        </Grid.Col>


                        <Grid.Col width={210}>
                            <NamedProperty valueAlign='center' previously={previous?.authorisation.from} currently={entry.authorisation.from}>
                                <Label noIcon title={<div className='apprise-row'
                                ><DateLabel noIcon noTip date={entry.authorisation.from} /> - <DateLabel style={entry.active ? { color: 'black', fontWeight: 500 } : {}} noIcon noTip date={entry.authorisation.to} />
                                </div>} />
                            </NamedProperty>
                        </Grid.Col>

                        <Grid.Col width={280}>
                            <NamedProperty previously={previous?.authorisation.authorisationNumber} currently={entry.authorisation.authorisationNumber}>
                                <Label noIcon title={entry.authorisation.authorisationNumber} />
                            </NamedProperty>
                        </Grid.Col>


                        <Grid.Col>
                            <NamedProperty previously={previous?.authorisation.authorisingEntity} currently={entry.authorisation.authorisingEntity}>
                                <Label tip={entry.authorisation.authorisingEntity} noIcon title={entry.authorisation.authorisingEntity} />
                            </NamedProperty>
                        </Grid.Col>


                        <Grid.Col width={130}>
                            <NamedProperty valueAlign='center' previously={previous?.revision.lifecycle.lastModified} currently={entry.revision.lifecycle.lastModified}>
                                <DateLabel noIcon date={entry.revision.lifecycle.lastModified} />
                            </NamedProperty>
                        </Grid.Col>

                    </Grid.Row>
                })
            }


        </Grid>
    </NamedPropertyContext.Provider>
}

